import ApiModel from './ApiModel'

class news extends ApiModel {
}

export default new news('/news');